import {ReactElement} from "react";
import {RendererProps} from "../RendererProps";
import {renewalIncreaseTypePrettyName} from "../../../../workflows/operational/renewal-rates/renewal-increase-helpers";
import {budgetSeasonString, ensureNotObject} from "../common";
import * as common from "../styles/common.module.scss";

export function RenderSetOriginalRevenuePropertyRenewalIncreasePercent(props: RendererProps): ReactElement {
    const typeEnum = props.variables["type"];
    const percent = props.variables["percent"];
    const budgetYear = props.variables["budgetYear"];

    if(!typeEnum || !percent || !budgetYear) {
        return <></>;
    }

    return <div>
        <div className={common.textHeader}>{budgetSeasonString(budgetYear)}</div>
        <div>{renewalIncreaseTypePrettyName(typeEnum)} with {ensureNotObject(percent)}% increase</div>
    </div>;
}